/* eslint-disable no-unused-vars */
import React from 'react';

import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
import Section0 from './section0';
import Section1 from './section1';
import Section2 from './section2';

interface ITopic900Props {
  settings: any;
}

const TopicOcre: React.FunctionComponent<ITopic900Props> = ({ settings }) => (
  <TopicContainer className="ocre">
    <TopicItem id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item ocre_2" id="2">
      <Section1 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item ocre_3" id="3">
      <Section2 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default TopicOcre;
